import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Alert, AlertActions, AlertBody, AlertDescription, AlertTitle, } from "catalyst/alert";
import { Button } from "catalyst/button";
import { Text } from "catalyst/text";
import { leaveHub, useProfile } from "../lib/api.js";
import { emailErrorMessage } from "../lib/email.js";
export function LeaveHubButton({ hub, outline = false, }) {
    const profileResponse = useProfile();
    const [open, setOpen] = useState(false);
    const [leaving, setLeaving] = useState(false);
    const [error, setError] = useState(null);
    const canLeave = !hub.is_personal && hub.role !== "owner";
    const name = hub.display_name?.trim() || hub.hub_name;
    async function leave() {
        if (!canLeave || leaving)
            return;
        setLeaving(true);
        setError(null);
        try {
            await leaveHub(hub.hub_id);
            setOpen(false);
            // Membership is already revoked. Remove it locally even if a later refresh fails.
            // The active hub falls back to the user's personal hub.
            await profileResponse
                .mutate((profile) => profile && {
                ...profile,
                hubs: profile.hubs.filter((item) => item.hub_id !== hub.hub_id),
            }, { revalidate: false })
                .catch(() => { });
        }
        catch (reason) {
            setError(emailErrorMessage(reason));
        }
        finally {
            setLeaving(false);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx(Button, { ...(outline ? { outline: true } : { plain: true }), onClick: () => {
                    setError(null);
                    setOpen(true);
                }, children: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0445\u0430\u0431" }), _jsxs(Alert, { open: open, onClose: (nextOpen) => {
                    if (!leaving)
                        setOpen(nextOpen);
                }, children: [_jsxs(AlertTitle, { children: ["\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0445\u0430\u0431 \u00AB", name, "\u00BB?"] }), _jsx(AlertDescription, { children: canLeave
                            ? "Вы потеряете доступ к хабу. Ваши чаты в нем будут удалены, а токены отозваны. Чтобы вернуться, потребуется новое приглашение."
                            : hub.is_personal
                                ? "Личный хаб нельзя покинуть."
                                : "Владелец не может покинуть хаб, пока не передаст эту роль другому участнику." }), error && (_jsx(AlertBody, { children: _jsx(Text, { role: "alert", className: "text-red-600! dark:text-red-500!", children: error }) })), _jsxs(AlertActions, { children: [_jsx(Button, { plain: true, disabled: leaving, onClick: () => setOpen(false), children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), canLeave && (_jsx(Button, { color: "orange", disabled: leaving, onClick: () => void leave(), children: leaving ? "Выходим…" : "Покинуть" }))] })] })] }));
}
